module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/xhr2/lib/browser.js
// module id = 3
// module chunks = 0